/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { InfluencerViewModel } from "../types/InfluencerViewModel.ts";

export const influencerViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do influenciador.")),
  name: z.string().describe("Nome do influenciador.").nullish(),
  email: z.string().describe("Endereço de e-mail do influenciador.").nullish(),
  affiliateCode: z
    .string()
    .describe("Código de afiliado único do influenciador.")
    .nullish(),
  active: z.optional(
    z.boolean().describe("Indica se o influenciador está ativo."),
  ),
}) as unknown as ToZod<InfluencerViewModel>;
